import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Uuid} from "../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../shared/services/auth.service";
import {DictService} from "../../../shared/services/dict.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FilterService} from "../../../shared/services/filter.service";
import {ReplaySubject} from "rxjs";
import {NgForm} from "@angular/forms";
import {MatPaginator} from "@angular/material/paginator";
import {AnalyticsService} from "../../../shared/services/analytics.service";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {InsuranceCompany} from "../../../shared/interface/insurance-company";

@Component({
  selector: 'app-report-registrations',
  templateUrl: './report-registrations.component.html',
  styleUrls: ['./report-registrations.component.scss']
})
export class ReportRegistrationsComponent implements OnInit, OnDestroy {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild('paginator') paginator: MatPaginator;

  initialFilters: any;
  userPermissions: ReplaySubject<UserPermissions>;
  selectedInsuranceCompanies?: InsuranceCompany[];


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private analyticsService: AnalyticsService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private dictService: DictService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private filterService: FilterService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.parseFilters();
  }

  ngOnInit(): void {
  }
  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      ofwca: 'string',
      contract: 'string',
      in$insuranceCompany: 'int[]',
      salesProfileType: 'int',
      insuranceCompanyType: 'int',
      in$status: 'int[]',
      salesProfileStatus: 'int',
      statements: 'int',
      company: 'int',
      partner: 'string',
      assetsRegional: 'string[]',
      lifeRegional: 'string[]',
      doubleRegistration: 'int',
      missingExam: 'int',
      activeKrk: 'int',
      passedExam100p: 'int',
      hasDiploma: 'int',
      agreedToDeregister: 'int',
      partnerTags: 'int[]',
      authorizationStatus: 'int',
      gte$authorizationGeneratedAt: 'date',
      lte$authorizationGeneratedAt: 'date',
      gte$createdAt: 'date',
      lte$createdAt: 'date',
      chronieAccess: 'int',
      chronieLogin: 'string',
      chronieDiscountCode: 'string',
      sentToBlock: 'int',
      blocked: 'int',
      agreedToRegisterInPzu: 'int',
      rauNumber: 'string',
      deregistrationPack: 'string',
      facilityStateOfwca: 'int',
    }, filters);
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: 10,
      ...this.filtersForm.value,
    })]);
  }
  downloadReport(): void {
    this.analyticsService.downloadReportRegistrations(this.initialFilters)
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: 10,
    }]);
  }
}
